import React from "react";
import { useTranslation } from "react-i18next";
import { uuid } from "uuidv4";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";

import store, {
    setIsHistoryModalOpened,
    setSelectedSaleSupports,
    setIsInputUpdated,
    setSelectedHistorySaleSupports,
    setSaleSupportToBeArchived,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setIsLoading,
    setKey,
} from "../store";
import { store as useStore } from "../../../../components/VerticalLayout/store";

import ErrorToast from "@components/Common/ErrorTost";
import { ConfirmationArchive } from "../ConfirmationArchive";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import { ID_SALE_SUPPORT_KIOSK, TOAST_LIMIT_DEFAULT } from "@constants/index";
import { generalConfigStore, setItemsDisable } from "@store";
import { setIsDataUpdated } from "@pages/Applications/Kiosk/store";
import { showSuccessToast } from "@components/Common/SuccessToast";
import {
    ArchivedArchivedSaleSupportFranchise,
    ArchivedSaleSupport,
    AssociateModeOfSale,
    createBaseConfig,
    createSaleSupportData,
    getAssociatedIds,
    getDataConfig,
} from "../utils/saleSupportHelpers";
import SaleSupportActions from "./SaleSupportActions";
import { useFetchGlobal } from "../../../../api/hooks";

export function CustomIcons({
    selectedRowData,
    setSaleSupport,
    userData,
    setIsAddSaleSupportClicked,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    setSelectedRows,
    isArchivedSaleSupportClicked,
    setIsFavoriteModified,
    setRowData,
    setLimit,
    setIsConsult,
    setDataState,
    setSalesModesTypesAndTag,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const {
        isInputUpdated,
        isHistoryModalOpened,
        shopsSaleSupportData,
        listFranchiseArchived,
        saleSupportData,
        saleSupportToBeArchived,
        isActionsClicked,
        isEdited,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { oneShop, operatorID, franchiseID } = useSnapshot(useStore);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const [saleSupportState, setSaleSupportState] = React.useState<boolean>(
        selectedRowData.selectedRow.isActive
    );

    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    const [isArchiveSVModalOpened, setIsArchiveSVModalOpened] = React.useState<
        boolean
    >(false);
    const uuidUser = localStorage.getItem("uuidUser");
    let dataArchive: any[] = [];
    let dataAssociate: any[] = [];

    if (!oneShop) {
        dataArchive = ArchivedSaleSupport(shopsSaleSupportData);
        dataAssociate = AssociateModeOfSale(
            shopsSaleSupportData,
            selectedRowData
        );
    } else {
        dataArchive = ArchivedArchivedSaleSupportFranchise(
            shopsSaleSupportData
        );
    }

    async function handleTrashButtonClicked(selectedRow: any) {
        try {
            setLimit(TOAST_LIMIT_DEFAULT);
            setIsLoading(true);

            const idsAssociated = getAssociatedIds(shopsSaleSupportData);

            if (
                selectedRow.shopId === "0" &&
                idsAssociated.includes(selectedRow.Id)
            ) {
                ErrorToast(
                    `${t(
                        "Please note that you cannot archive an item assigned to stores."
                    )!}`
                );
                setIsLoading(false);
                return;
            }

            const listOfSaleSupport = encodeURIComponent(
                selectedRowData.selectedRow.Id
            );
            const requestOptions: RequestInit = {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            };

            let saleSupportUsed: any[] = [];

            const result = await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/isSaleSupportUsed?userId=${userData.userId}&shopId=${selectedRow.shopId}&franchiseId=${userData.franchiseId}&saleSupport=${listOfSaleSupport}`,
                requestOptions
            );

            if (result?.saleSupportUsed?.length > 0) {
                saleSupportUsed = result.saleSupportUsed;
                ErrorToast(
                    `${t("Attention, you cannot archive a used element.")}`
                );
                setIsLoading(false);
            }

            if (
                saleSupportUsed.length === 0 &&
                ((selectedRow.shopId === "0" &&
                    !idsAssociated.includes(selectedRow.Id) &&
                    !oneShop) ||
                    oneShop)
            ) {
                setIsArchiveSVModalOpened(true);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            ErrorToast(`${t("There's an error")}!`);
        }
    }
    async function ClickEventEdit() {
        const shopId = selectedRowData.selectedRow.shopId;
        try {
            const requestOptions: RequestInit = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    franchiseId: franchiseID,
                    shopId,
                    state: !selectedRowData?.selectedRow.isActive,
                }),
            };
            const result = await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/application/modif-all-app-state`,
                requestOptions
            );
            if (result.error) {
                throw new Error("Error in application status!");
            }
            showSuccessToast(
                `${t("Application status updated successfully")!}`
            );
        } catch (error) {
            ErrorToast(`${t("There's an error")}!`);
        }
    }

    async function handleStateChange(state: boolean) {
        try {
            setLimit(TOAST_LIMIT_DEFAULT);
            setIsLoading(true);
            const dataConfig = getDataConfig({
                userData,
                selectedRowData,
                operatorID,
                uuidUser,
                state,
            });

            const requestOptions: RequestInit = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataConfig),
            };

            const result = await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`,
                requestOptions
            );

            if (result.error) {
                throw new Error(result.message);
            }
            showSuccessToast(
                state
                    ? `${t("Sale support has been successfully activated")}`
                    : `${t("Sale support has been successfully deactivated")}`
            );

            if (selectedRowData.selectedRow.Id === ID_SALE_SUPPORT_KIOSK) {
                await ClickEventEdit();

                if (state === false) {
                    const alreadyExists = itemsDisable.find(
                        (item: any) =>
                            item.id === selectedRowData.selectedRow.Id &&
                            item.shopId === selectedRowData.selectedRow.shopId
                    );

                    if (!alreadyExists) {
                        const updatedItems = [
                            ...itemsDisable,
                            {
                                id: selectedRowData.selectedRow.Id,
                                state: false,
                                shopId: selectedRowData.selectedRow.shopId,
                            },
                        ];
                        setItemsDisable(updatedItems);
                        localStorage.setItem(
                            "itemsDisable",
                            JSON.stringify(updatedItems)
                        );
                    }
                } else {
                    const updatedItems = itemsDisable.filter(
                        (item: any) =>
                            !(
                                item.id === selectedRowData.selectedRow.Id &&
                                item.shopId ===
                                    selectedRowData.selectedRow.shopId
                            )
                    );
                    setItemsDisable(updatedItems);
                    localStorage.setItem(
                        "itemsDisable",
                        JSON.stringify(updatedItems)
                    );
                }
            }

            setTimeout(() => setIsLoading(false), 3000);
        } catch (error) {
            ErrorToast(`${t("There's an error")}!`);
            setIsLoading(false);
        }
    }

    async function handleActiveSaleSupport(selectedRowData: any) {
        try {
            setLimit(TOAST_LIMIT_DEFAULT);
            setIsLoading(true);
            const baseConfig = createBaseConfig(
                userData,
                selectedRowData.selectedRow,
                operatorID,
                uuidUser
            );
            const saleSupportData = createSaleSupportData(
                selectedRowData.selectedRow,
                {
                    isFavorite: false,
                    isActive:
                        selectedRowData.selectedRow.shopId === "0"
                            ? true
                            : selectedRowData.selectedRow.isActive,
                    isArchived: false,
                }
            );
            const dataConfig = [
                {
                    ...baseConfig,
                    data: {
                        [selectedRowData.selectedRow.Id]: saleSupportData,
                    },
                },
            ];
            const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;
            const requestOptions: RequestInit = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataConfig),
            };
            const result = await fetchGlobal<any>(apiUrl, requestOptions);
            if (result.error) {
                throw new Error(result.message);
            }
            showSuccessToast(`${t("Sale support is successfully unarchived")}`);
            setKey(uuid());
            setIsDataUpdated!(true);
            setIsLoading(false);
        } catch (error) {
            ErrorToast(`${t("There's an error")}!`);
            setIsLoading(false);
        }
    }

    async function handleArchiveSaleSupport(element: any) {
        try {
            setLimit(TOAST_LIMIT_DEFAULT);
            setIsLoading(true);
            const baseConfig = createBaseConfig(
                userData,
                element,
                operatorID,
                uuidUser
            );
            const saleSupportData = createSaleSupportData(element, {
                isActive: false,
                isArchived: true,
            });
            const dataConfig = [
                {
                    ...baseConfig,
                    data: {
                        [element.Id]: saleSupportData,
                    },
                },
            ];

            const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;
            const requestOptions: RequestInit = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataConfig),
            };
            const result = await fetchGlobal<any>(apiUrl, requestOptions);
            if (result.error) {
                throw new Error(result.message);
            }
            showSuccessToast(`${t("Sale Support is successfully archived")}`);
            setKey(uuid());
            setIsLoading(false);
        } catch (error) {
            ErrorToast(`${t("There's an error")}!`);
            setIsLoading(false);
        }
    }

    async function favoriteSaleSupport(element: any) {
        try {
            setLimit(TOAST_LIMIT_DEFAULT);
            setIsLoading(true);
            toast.dismiss();

            const baseConfig = createBaseConfig(
                userData,
                element.selectedRow,
                operatorID,
                uuidUser
            );

            const alreadyFavorite = saleSupportData.find(
                (item: any) => item.isFavorite === true
            );

            const dataSS = saleSupportData
                .filter(
                    (item: any) =>
                        item.Id === element.selectedRow.Id ||
                        item.Id === alreadyFavorite?.Id
                )
                .map((saleSupport: any) => ({
                    ...baseConfig,
                    isShop: oneShop,
                    data: {
                        [saleSupport.Id]: createSaleSupportData(saleSupport, {
                            isFavorite:
                                saleSupport.Id === element.selectedRow.Id,
                        }),
                    },
                }));

            const requestOptions: RequestInit = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(dataSS),
            };

            const data = await fetchGlobal<any>(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`,
                requestOptions
            );

            if (data.error) {
                throw new Error("Error in favoriteSaleSupport");
            }

            showSuccessToast(
                dataAssociate.length > 0
                    ? t(
                          "Franchise favorite state has been successfully activated"
                      )
                    : t("Favorite state has been enabled successfully")
            );

            setKey(uuid());
            if (dataAssociate.length > 0) {
                setIsFavoriteModified(true);
            }

            setTimeout(() => setIsLoading(false), 3000);
        } catch (error) {
            ErrorToast(`${t("There's an error")}!`);
        }
    }

    React.useEffect(() => {
        if (isValidateClicked === true) {
            handleArchiveSaleSupport(saleSupportToBeArchived);
        }
        // eslint-disable-next-line
    }, [isValidateClicked]);
    return (
        <React.Fragment>
            <div className="d-flex justify-content-around">
                <SaleSupportActions
                    modify={modify}
                    isEdited={isEdited}
                    isArchivedSaleSupportClicked={isArchivedSaleSupportClicked}
                    isLoading={isLoading}
                    oneShop={oneShop}
                    selectedRowData={selectedRowData}
                    saleSupportState={saleSupportState}
                    dataArchive={dataArchive}
                    listFranchiseArchived={listFranchiseArchived}
                    isActionsClicked={isActionsClicked}
                    isInputUpdated={isInputUpdated}
                    isModalConfirmationOpened={isModalConfirmationOpened}
                    isHistoryModalOpened={isHistoryModalOpened}
                    t={t}
                    setIsActionsClicked={setIsActionsClicked}
                    setActions={setActions}
                    setIsEdited={setIsEdited}
                    setSaleSupport={setSaleSupport}
                    setIsAddSaleSupportClicked={setIsAddSaleSupportClicked}
                    setIsInputUpdated={setIsInputUpdated}
                    setIsConsult={setIsConsult}
                    setIsLoading={setIsLoading}
                    setRowData={setRowData}
                    favoriteSaleSupport={favoriteSaleSupport}
                    ErrorToast={ErrorToast}
                    setSaleSupportState={setSaleSupportState}
                    handleStateChange={handleStateChange}
                    setDataState={setDataState}
                    setMessage={setMessage}
                    setYesFunction={setYesFunction}
                    setActivationDeactivationMessageModalOpened={
                        setActivationDeactivationMessageModalOpened
                    }
                    setSaleSupportToBeArchived={setSaleSupportToBeArchived}
                    handleTrashButtonClicked={handleTrashButtonClicked}
                    setSelectedRows={setSelectedRows}
                    setIsModalConfirmationOpened={setIsModalConfirmationOpened}
                    handleActiveSaleSupport={handleActiveSaleSupport}
                    setIsHistoryModalOpened={setIsHistoryModalOpened}
                    setSelectedSaleSupports={setSelectedSaleSupports}
                    setSelectedHistorySaleSupports={
                        setSelectedHistorySaleSupports
                    }
                    setSalesModesTypesAndTag={setSalesModesTypesAndTag}
                />
            </div>
            {isArchiveSVModalOpened ? (
                <ConfirmationArchive
                    isArchiveSVModalOpened={isArchiveSVModalOpened}
                    setIsArchiveSVModalOpened={setIsArchiveSVModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
        </React.Fragment>
    );
}
